import { Injectable } from "@angular/core";

@Injectable()
export class SignpadService {
    public service: any;

    constructor() {
        this.service = jsService();

        this.service.setDriverAvailability();

        function jsService() {
            let wgssSignatureSDK = null;
            let sigObj = null;
            let sigCtl = null;
            let dynCapt = null;
            let driverInstalled = false;
            const JSONreq = (window as any).JSONreq;
            const WacomGSS_SignatureSDK = (window as any).WacomGSS_SignatureSDK;

            const parameter: any = {};

            const service = {
                isAvailable: isAvailable,
                setDriverAvailability: setDriverAvailability,
                capture: capture,
            };

            function isAvailable(notAvailableCallback, otherErrorCallback) {
                if (driverInstalled) {
                    restartSession(
                        null,
                        notAvailableCallback,
                        otherErrorCallback,
                    );
                } else if (notAvailableCallback) {
                    notAvailableCallback();
                }
            }

            function setDriverAvailability() {
                setTimeout(function () {
                    const data = { GetPort: 1 };
                    JSONreq.getJSON(
                        "https://localhost:8000/wacom.js",
                        data,
                        function () {
                            driverInstalled = true;
                        },
                        function () {
                            driverInstalled = false;
                        },
                    );
                }, 1000);
            }

            function capture(
                who,
                why,
                width,
                height,
                imgCallback,
                notAvailableCallback,
                otherErrorCallback,
            ) {
                parameter.who = who;
                parameter.why = why;
                parameter.width = width;
                parameter.height = height;
                parameter.imgCallback = imgCallback;
                parameter.notAvailableCallback = notAvailableCallback;
                parameter.otherErrorCallback = otherErrorCallback;
                doCapture();
            }

            function doCapture() {
                if (!driverInstalled) {
                    if (parameter.notAvailableCallback) {
                        parameter.notAvailableCallback();
                    }

                    return;
                }

                if (
                    wgssSignatureSDK == undefined ||
                    !wgssSignatureSDK.running ||
                    null == dynCapt
                ) {
                    print("Session error. Restarting the session.");
                    restartSession(
                        doCapture,
                        parameter.notAvailableCallback,
                        parameter.otherErrorCallback,
                    );
                    return;
                }
                dynCapt.Capture(
                    sigCtl,
                    parameter.who,
                    parameter.why,
                    null,
                    null,
                    onDynCaptCapture,
                );

                function onDynCaptCapture(dynCaptV, SigObjV, status) {
                    if (
                        wgssSignatureSDK.ResponseStatus.INVALID_SESSION ==
                        status
                    ) {
                        print(
                            "Error: invalid session. Restarting the session.",
                        );
                        restartSession(
                            doCapture,
                            parameter.notAvailableCallback,
                            parameter.otherErrorCallback,
                        );
                    } else {
                        if (
                            wgssSignatureSDK.DynamicCaptureResult.DynCaptOK !=
                            status
                        ) {
                            print("Capture returned: " + status);
                        }
                        switch (status) {
                            case wgssSignatureSDK.DynamicCaptureResult
                                .DynCaptOK:
                                sigObj = SigObjV;
                                print("Signature captured successfully");
                                var flags =
                                    wgssSignatureSDK.RBFlags
                                        .RenderOutputBase64 |
                                    wgssSignatureSDK.RBFlags.RenderColor24BPP |
                                    wgssSignatureSDK.RBFlags.RenderEncodeData;
                                sigObj.RenderBitmap(
                                    "png",
                                    parameter.width,
                                    parameter.height,
                                    0.7,
                                    0x00000000,
                                    0x00ffffff,
                                    flags,
                                    0,
                                    0,
                                    onRenderBitmap,
                                );
                                break;
                            case wgssSignatureSDK.DynamicCaptureResult
                                .DynCaptCancel:
                                print("Signature capture cancelled");
                                break;
                            case wgssSignatureSDK.DynamicCaptureResult
                                .DynCaptPadError:
                                parameter.otherErrorCallback();
                                print("No capture service available");
                                break;
                            case wgssSignatureSDK.DynamicCaptureResult
                                .DynCaptError:
                                print("Tablet Error");
                                break;
                            case wgssSignatureSDK.DynamicCaptureResult
                                .DynCaptIntegrityKeyInvalid:
                                print(
                                    "The integrity key parameter is invalid (obsolete)",
                                );
                                break;
                            case wgssSignatureSDK.DynamicCaptureResult
                                .DynCaptNotLicensed:
                                print(
                                    "No valid Signature Capture licence found",
                                );
                                break;
                            case wgssSignatureSDK.DynamicCaptureResult
                                .DynCaptAbort:
                                print(
                                    "Error - unable to parse document contents",
                                );
                                break;
                            default:
                                print("Capture Error " + status);
                                break;
                        }
                    }
                }

                function onRenderBitmap(sigObjV, bmpObj, status) {
                    if (wgssSignatureSDK.ResponseStatus.OK == status) {
                        parameter.imgCallback(bmpObj.image);
                    } else {
                        print("Signature Render Bitmap error: " + status);
                    }
                }
            }

            function print(txt) {}

            function restartSession(
                callback,
                notAvailableCallback,
                otherErrorCallback,
            ) {
                wgssSignatureSDK = null;
                sigObj = null;
                sigCtl = null;
                dynCapt = null;

                // pass the starting service port  number as configured in the registry
                wgssSignatureSDK = new WacomGSS_SignatureSDK(
                    onDetectRunning,
                    8000,
                );

                function onDetectRunning() {
                    if (wgssSignatureSDK.running) {
                        print("Signature SDK Service detected.");
                        start();
                    } else {
                        print("Signature SDK Service not detected.");
                        notAvailableCallback();
                    }
                }

                function start() {
                    if (wgssSignatureSDK.running) {
                        sigCtl = new wgssSignatureSDK.SigCtl(
                            onSigCtlConstructor,
                        );
                    }
                }

                function onSigCtlConstructor(sigCtlV, status) {
                    if (wgssSignatureSDK.ResponseStatus.OK == status) {
                        dynCapt = new wgssSignatureSDK.DynamicCapture(
                            onDynCaptConstructor,
                        );
                    } else {
                        print("SigCtl constructor error: " + status);
                        otherErrorCallback();
                    }
                }

                function onDynCaptConstructor(dynCaptV, status) {
                    if (wgssSignatureSDK.ResponseStatus.OK == status) {
                        sigCtl.GetSignature(onGetSignature);
                    } else {
                        print("DynCapt constructor error: " + status);
                        otherErrorCallback();
                    }
                }

                function onGetSignature(sigCtlV, sigObjV, status) {
                    if (wgssSignatureSDK.ResponseStatus.OK == status) {
                        sigObj = sigObjV;
                        sigCtl.GetProperty(
                            "Component_FileVersion",
                            onSigCtlGetProperty,
                        );
                    } else {
                        print("SigCapt GetSignature error: " + status);
                        otherErrorCallback();
                    }
                }

                function onSigCtlGetProperty(sigCtlV, property, status) {
                    if (wgssSignatureSDK.ResponseStatus.OK == status) {
                        print("DLL: flSigCOM.dll  v" + property.text);
                        dynCapt.GetProperty(
                            "Component_FileVersion",
                            onDynCaptGetProperty,
                        );
                    } else {
                        print("SigCtl GetProperty error: " + status);
                        otherErrorCallback();
                    }
                }

                function onDynCaptGetProperty(dynCaptV, property, status) {
                    if (wgssSignatureSDK.ResponseStatus.OK == status) {
                        print("DLL: flSigCapt.dll v" + property.text);
                        print("Test application ready.");
                        print("Press 'Start' to capture a signature.");
                        if ("function" === typeof callback) {
                            callback();
                        }
                    } else {
                        print("DynCapt GetProperty error: " + status);
                        otherErrorCallback();
                    }
                }
            }

            function DisplaySignatureDetails() {
                if (!wgssSignatureSDK.running || null == sigObj) {
                    print("Session error. Restarting the session.");
                    restartSession(DisplaySignatureDetails, null, null);
                    return;
                }
                sigObj.GetIsCaptured(onGetIsCaptured);

                function onGetIsCaptured(sigObj, isCaptured, status) {
                    if (wgssSignatureSDK.ResponseStatus.OK == status) {
                        if (!isCaptured) {
                            print("No signature has been captured yet.");
                            return;
                        }
                        sigObj.GetWho(onGetWho);
                    } else {
                        print("Signature GetWho error: " + status);
                        if (
                            wgssSignatureSDK.ResponseStatus.INVALID_SESSION ==
                            status
                        ) {
                            print("Session error. Restarting the session.");
                            restartSession(DisplaySignatureDetails, null, null);
                        }
                    }
                }

                function onGetWho(sigObjV, who, status) {
                    if (wgssSignatureSDK.ResponseStatus.OK == status) {
                        print("  Name:   " + who);
                        const tz = wgssSignatureSDK.TimeZone.TimeLocal;
                        sigObj.GetWhen(tz, onGetWhen);
                    } else {
                        print("Signature GetWho error: " + status);
                    }
                }

                function onGetWhen(sigObjV, when, status) {
                    if (wgssSignatureSDK.ResponseStatus.OK == status) {
                        print("  Date:   " + when.toString());
                        sigObj.GetWhy(onGetWhy);
                    } else {
                        print("Signature GetWhen error: " + status);
                    }
                }

                function onGetWhy(sigObjV, why, status) {
                    if (wgssSignatureSDK.ResponseStatus.OK == status) {
                        print("  Reason: " + why);
                    } else {
                        print("Signature GetWhy error: " + status);
                    }
                }
            }

            function AboutBox() {
                if (!wgssSignatureSDK.running || null == sigCtl) {
                    print("Session error. Restarting the session.");
                    restartSession(AboutBox, null, null);
                    return;
                }
                sigCtl.AboutBox(onAboutBox);
                function onAboutBox(sigCtlV, status) {
                    if (wgssSignatureSDK.ResponseStatus.OK != status) {
                        print("AboutBox error: " + status);
                        if (
                            wgssSignatureSDK.ResponseStatus.INVALID_SESSION ==
                            status
                        ) {
                            print("Session error. Restarting the session.");
                            restartSession(AboutBox, null, null);
                        }
                    }
                }
            }

            return service;
        }
    }
}
